import { render, staticRenderFns } from "./add-paper-from-dio.html?vue&type=template&id=05d98735&scoped=true&"
import script from "./add-paper-from-dio.js?vue&type=script&lang=js&"
export * from "./add-paper-from-dio.js?vue&type=script&lang=js&"
import style0 from "./add-paper-from-dio.scss?vue&type=style&index=0&id=05d98735&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d98735",
  null
  
)

export default component.exports